import { useRef } from 'react'
import { Upload } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const InvoiceUploadButton = ({
  disabled,
  isUploading,
  onPickFile,
}: {
  disabled: boolean
  isUploading: boolean
  onPickFile: (file: File) => void | Promise<void>
}) => {
  const { t } = useLocalization()
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <Column className="gap-2">
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,image/png,image/jpeg,image/webp"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0]
          e.target.value = ''
          if (file) void onPickFile(file)
        }}
      />

      <Row>
        <Button
          variant="primary"
          disabled={disabled || isUploading}
          type="button"
          onClick={() => inputRef.current?.click()}
        >
          <Upload className="h-4 w-4 mr-2" aria-hidden />
          {isUploading
            ? t('Uploading…', 'Laddar upp…')
            : t('Upload invoice', 'Ladda upp faktura')}
        </Button>
      </Row>
    </Column>
  )
}
